import { cn } from "@/marketing/lib/utils";

interface KpiCardProps {
  label: string;
  value: string;
  hint: string;
  highlight?: boolean;
}

function KpiCard({ label, value, hint, highlight }: KpiCardProps) {
  return (
    <div className="tw-rounded-lg tw-border tw-border-border tw-bg-card tw-px-4 tw-py-3">
      <div className="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-muted-foreground">
        {label}
      </div>
      <div
        className={cn(
          "tw-mt-1 tw-text-2xl tw-font-bold tw-leading-none",
          highlight ? "tw-text-red-600" : "tw-text-foreground",
        )}
      >
        {value}
      </div>
      <div className="tw-mt-1 tw-text-xs tw-text-muted-foreground">{hint}</div>
    </div>
  );
}

interface CampaignKpiCardsProps {
  inProgress: number;
  onboardingTarget: number;
  postTarget: number;
  dueThisWeek: number;
}

export function CampaignKpiCards({
  inProgress,
  onboardingTarget,
  postTarget,
  dueThisWeek,
}: CampaignKpiCardsProps) {
  return (
    <div className="tw-grid tw-grid-cols-2 tw-gap-3 md:tw-grid-cols-4">
      <KpiCard
        label="Active campaigns"
        value={String(inProgress)}
        hint="In progress"
      />
      <KpiCard
        label="Onboarding target"
        value={String(onboardingTarget)}
        hint="Across visible campaigns"
      />
      <KpiCard
        label="Post target"
        value={String(postTarget)}
        hint="Across visible campaigns"
      />
      <KpiCard
        label="Due this week"
        value={String(dueThisWeek)}
        hint="Posting deadlines"
        highlight={dueThisWeek > 0}
      />
    </div>
  );
}
